import type { ContactResponse } from "../../../types/common";

const KEY = "accountInfosCache";

type CachePayload = {
    savedAt: number;
    ttlMs?: number;
    data: ContactResponse[];
};

const DEFAULT_TTL_MS = 30 * 60 * 1000;

export function loadAccountInfosFromSession(): ContactResponse[] {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return [];

        const payload: CachePayload = JSON.parse(raw);

        const ttl = payload.ttlMs ?? DEFAULT_TTL_MS;
        if (ttl && Date.now() - payload.savedAt > ttl) return [];

        return Array.isArray(payload.data) ? payload.data : [];
    } catch {
        return [];
    }
}

export function saveAccountInfosToSession(data: ContactResponse[], ttlMs = DEFAULT_TTL_MS) {
    const payload: CachePayload = {
        savedAt: Date.now(),
        ttlMs,
        data,
    };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
}

export function clearAccountInfosSession() {
    sessionStorage.removeItem(KEY);
}